import React, { useState, useEffect } from 'react';
import { Radio, Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import ApiService from '../../services/ApiService';
import Wrapper from '../Common/Wrapper';

const EntitySelector = ({ onEntitySelect, onQueryByChange, queryBy, selectedEntity }) => {
  const [searchValue, setSearchValue] = useState(null);
  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [users, setUsers] = useState([]);
  const [taxRegistrationNumbers, setTaxRegistrationNumbers] = useState([]);

  useEffect(() => {
    if ((!users || users.length === 0)) {
      fetchInitialData();
    }
  }, [users]);

  const fetchInitialData = async () => {
    const { data: usersData } = await ApiService.getUsers();
    const uniqueUsersData = Array.from(new Map(usersData.map(item => [item.userId, item])).values());
    const usersArray = uniqueUsersData.map((x) => ({
      ...x,
      key: x.userId,
    }));
    setUsers(usersArray);

    const uniqueVatNumbers = Array.from(new Map(usersData.map(item => [item.taxRegistrationNumber, item])).values())
    const uniqueVatArray = uniqueVatNumbers.map((x) => ({
      ...x,
      key: x.taxRegistrationNumber,
    }));
    setTaxRegistrationNumbers(uniqueVatArray);
  };

  const fetchEntities = async (searchValue) => {
    if (!searchValue) {
      setData([]);
      return;
    }

    setFetching(true);
    if (queryBy === 'userId') {
      const filteredUsers = users.filter(u =>
        (u.userId && u.userId.toLowerCase().includes(searchValue.toLowerCase()))
      );
      setData(filteredUsers);
    } else if (queryBy === 'taxRegistrationNumber') {
      const filteredVats = taxRegistrationNumbers.filter(v => v.taxRegistrationNumber.includes(searchValue));
      setData(filteredVats);
    }
    setFetching(false);
  };

  const debouncedFetchEntities = debounce(fetchEntities, 800);

  const handleQueryByChange = (e) => {
    const value = e.target.value;
    setSearchValue(null);
    setData([]);
    onQueryByChange(value);
  };

  const handleSearch = (value) => {
    setSearchValue(value);
    debouncedFetchEntities(value);
  };

  const handleChange = (value) => {
    onEntitySelect(value);
  };

  return (
    <Wrapper>
      <div className="query-options">
        <Radio.Group onChange={handleQueryByChange} value={queryBy}>
          <Radio value="userId">Χρήστης</Radio>
          <Radio value="taxRegistrationNumber">ΑΦΜ</Radio>
          <Radio value="default">Default</Radio>
        </Radio.Group>
      </div>

      <div className="search-select">
        {queryBy !== 'default' && (
          <Select
            showSearch
            value={selectedEntity}
            placeholder={`Αναζήτηση με ${queryBy === 'userId' ? 'Username': 'ΑΦΜ Πελάτη'}`}
            style={{ width: 300 }}
            defaultActiveFirstOption={false}
            showArrow={false}
            filterOption={false}
            onSearch={handleSearch}
            onChange={handleChange}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            options={(data || []).map((d) => ({
              value: d[queryBy],
              label: d[queryBy]
            }))}
          />
        )}
      </div>
    </Wrapper>
  );
};

export default EntitySelector;
